<template>
    <div class="navigator">
        <h2 class="mr-auto">{{ selectedProduct ? selectedProduct.name : 'New Product' }}</h2>
        <slot name="actionButtons"></slot>
    </div>
</template>

<script>
    export default {
        props: {
            selectedProduct: {
                type: Object,
                required: false,
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ProductNavigator.vue?f0a0e752